/**
 * Class which encapsulates all functionality related to finding and initiating animations on the site.
 */
export default class SiteAni {
  // Initialise the Intersection Observer
  constructor() {
    this.observer = null;
  }

  // Initialise the class
  init() {
    // Initialise DOM elements cache
    this.cacheDomElements();

    // Throttle scroll event
    this.throttleScrollEvent();

    // Initialise Intersection Observer
    this.initIntersectionObserver();

    // Listen for custom event if needed
    window.addEventListener("site-ani-find", () => {
      this.findAni();
    });
  }

  cacheDomElements() {
    this.groups = document.querySelectorAll(".site-ani-group");
    this.aniAutoElements = document.querySelectorAll(".site-ani-auto");
    // console.log('GROUPS: ', this.groups);
    // console.log('ANITAMTION ELEMENTS: ', this.aniAutoElements);
  }

  throttleScrollEvent() {
    let throttleTimeout;
    const throttleDelay = 100; // milliseconds

    window.addEventListener("scroll", () => {
      if (!throttleTimeout) {
        throttleTimeout = setTimeout(() => {
          throttleTimeout = null;
        }, throttleDelay);
      }
    });
  }

  initIntersectionObserver() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const target = entry.target;
            // Apply custom delay and duration from data attributes if present
            const delay = target.getAttribute("data-ani-delay") || "0";
            const duration = target.getAttribute("data-ani-duration") || "500";
            target.style.transitionDelay = `${delay}ms`;
            target.style.transitionDuration = `${duration}ms`;
            target.classList.add("state-ani-go");
          }
        });
      },
      { threshold: 0.1 }
    ); // Configurable threshold

    // Observe each .site-ani-auto element
    this.aniAutoElements.forEach((element) => this.observer.observe(element));
  }

  // Define any additional manually trigger animations or additional checks here (if needed)
  findAni() {}

  // Helper method for visibility checking, kept for reference or direct calls if needed
  inViewport(element, threshold = 0.1) {
    const box = element.getBoundingClientRect();
    const viewportHeight =
      window.innerHeight || document.documentElement.clientHeight;
    const viewportWidth =
      window.innerWidth || document.documentElement.clientWidth;

    const inViewportVertically =
      box.top + box.height * threshold < viewportHeight &&
      box.bottom - box.height * threshold > 0;
    const inViewportHorizontally =
      box.left + box.width * threshold < viewportWidth &&
      box.right - box.width * threshold > 0;

    return inViewportVertically && inViewportHorizontally;
  }
}
